var styles = {"dateRangeOutput":"styles_date-range-output__59pyp","separator":"styles_separator__caUEz"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
